import { Select, Space, Typography } from 'antd';
import { filterOption } from 'modules/utilities/utility';
import React from "react";
const { Text } = Typography;

function StatusFilter({ selectedStatus, setSelectedStatus }) {

  const optionList = [
    { value: "2", label: "Open" },
    { value: "3", label: "Pending" },
    { value: "5", label: "Closed" },
    { value: "4", label: "Resolved" },
  ];

  const handleSelect = data => setSelectedStatus(data);

  return (
    <>
      <Space.Compact block className='my-2'>
        <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }} className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
          <Text>Select Status</Text>
        </span>
        <Select
          mode="multiple"
          style={{ width: '70%' }}
          showSearch
          allowClear
          value={selectedStatus}
          placeholder='Status'
          optionFilterProp='children'
          onChange={handleSelect}
          filterOption={filterOption}
          options={optionList}
        />
      </Space.Compact>
    </>
  );
}

export default StatusFilter;
